import { memo } from "react";
import { Link } from "react-router-dom";
import { useShopifyProductsByHandles } from "@/hooks/useShopifyProductsByHandles";
import ShopifyProductGrid from "@/components/ShopifyProductGrid";
import { BESTSELLER_HANDLES } from "@/lib/bagCategories";

const ProductGrid = memo(() => {
  const { products, loading } = useShopifyProductsByHandles(BESTSELLER_HANDLES.slice(0, 8));

  return (
    <section className="py-20 md:py-28" id="shop">
      <div className="container px-6">
        <div className="text-center mb-14">
          <p className="font-body text-xs tracking-[0.3em] uppercase text-muted-foreground mb-3">
            Curated Selection
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground">
            Best Sellers
          </h2>
        </div>

        <ShopifyProductGrid products={products} loading={loading} columns={4} />

        <div className="text-center mt-12">
          <Link
            to="/bags"
            className="inline-flex items-center font-body text-sm tracking-wide text-foreground border-b border-foreground pb-0.5 hover:text-muted-foreground hover:border-muted-foreground transition-colors"
          >
            Shop All Bags →
          </Link>
        </div>
      </div>
    </section>
  );
});

ProductGrid.displayName = "ProductGrid";

export default ProductGrid;
